<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>登革热防治技能深度培训：提升公共卫生应对能力</h2>
        <div id="meta_content">
          <span class="rich_b"> 东进防控 </span>
          <span id="rich_c">
            <span>2025-04-21 15:04</span>
            广东
          </span>
        </div>
        <p>
          4月16日、17日，东进公司携手石排镇相关部门、常平镇镇爱卫会成员单位、各村（社区）、物业小区相关负责人，成功举办了以“科学防控登革热”为主题的预防知识培训活动。此次培训的核心目标在于深化公众对登革热的认知，强化防范意识，携手营造一个健康、安全的生活环境。
        </p>
        <img width="100%" :src="img[0]" alt="" />
        <p>
          培训现场，东进品质运营部葛庆喜总监以资深讲师专业视角，详尽阐述了登革热的传播、登革热的传播机制与典型症状及其潜在危害。登革热主要通过白纹伊蚊（即“花斑蚊”）叮咬传播，其症状涵盖突发高热、剧烈头痛、关节疼痛及皮疹等，严重时甚至可能危及生命。通过此次科普，参训人员对登革热有了更为全面且深入的了解。针对登革热的防控要点，讲师特别强调了“清积水、灭成蚊、防叮咬”三大关键策略。培训过程中，还着重强调了社区联动的不可或缺性，号召广大居民积极投身环境卫生整治行动，共同消除蚊虫滋生的温床。
        </p>
        <img width="100%" :src="img[1]" alt="" />
        <p>
          东进公司将继续秉承“服务社会、守护健康”的宗旨，与镇街及社会各界携手合作，持续开展登革热防控宣传活动，推动防控知识进社区、进家庭、进学校，为推动公共卫生安全贡献力量。
        </p>
        <h3>我们还提供多元化服务</h3>
        <img width="100%" :src="img[2]" alt="" />
        <h3>扫码关注我们了解更多</h3>
        <div>
          <img :src="img[3]" alt="" />
        </div>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span>&nbsp;</span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News12' })"
            >东交智慧物业公司正式起航...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span
          >
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: [
        require("@/assets/news13_1.jpg"),
        require("@/assets/news13_2.jpg"),
        require("@/assets/news8-4.png"),
        require("@/assets/news8-7.png"),
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.black {
  font-weight: 700;
}

.kongxi {
  height: 10px;
}

.big-div {
  display: flex;
  justify-content: space-evenly;
}

.small-div {
  text-align: center;
}

.small-div1 img {
  width: 258px;
  height: 258px;
}

.small-div2 img {
  width: auto;
  height: auto;
}

.caption {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-family: 黑体, SimHei;
    font-size: 18px;
    margin: 20px 0;
    text-align: left;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}

.wenzi {
  margin: 0 !important;
  color: rgb(255, 255, 255) !important;
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 20px 0;
      text-align: left;
    }

    p {
      margin: 10px 0;
      text-align: justify;
      text-indent: 2em;
      font-size: 16px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}

#meta_content {
  font-size: 15px;
  padding-left: 2.6em;

  span {
    color: rgba(0, 0, 0, 0.3);
  }

  .rich_b {
    color: #576b95 !important;
  }
}
</style>
